import { AppConfigModel } from "../abstract/app-config.model";

export class AccountingMethod extends AppConfigModel {

    static override CLASS_NAME: string = 'AccountingMethod';
}
